module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavyrain@2-a9cd9130db16b5dcbb2cc5fb9e63c9b7.png";